module.exports = __webpack_public_path__ + "img/404page.b5c1680e.svg";